/**
 * Get email, code, deliveryId, and executedBy from URL query parameters
 */
export function getAuthParamsFromUrl(): {
  email: string | null
  code: string | null
  deliveryId: string | null
  executedBy: string | null
} {
  const params = new URLSearchParams(window.location.search)
  return {
    email: params.get('email'),
    code: params.get('code'),
    deliveryId: params.get('delivery-id'),
    executedBy: params.get('executed-by'),
  }
}

/**
 * Encode a string as base64 using UTF-8, supporting non-ASCII characters.
 */
function base64EncodeUtf8(value: string): string {
  const encoder = new TextEncoder()
  const bytes = encoder.encode(value)
  let binary = ''
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i])
  }
  return btoa(binary)
}

/**
 * Generate Basic auth token from email and code
 * Format: base64(email:code)
 */
export function generateBasicAuthToken(email: string, code: string): string {
  const credentials = `${email}:${code}`
  return base64EncodeUtf8(credentials)
}

/**
 * Get authorization header value
 * Returns "Basic {token}" format
 */
export function getAuthorizationHeader(email: string, code: string): string {
  const token = generateBasicAuthToken(email, code)
  return `Basic ${token}`
}
